/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { cybertConfig } from './cybert';
import { gstackConfig } from './gstack';
import { bfaiConfig } from './bfai';
import { BrandConfig } from './types';

// Get brand from environment variable, default to 'gstack'
const BRAND = process.env.BRAND || 'gstack';

// Export the active brand configuration
export const brandConfig: BrandConfig = 
  BRAND === 'gstack' ? gstackConfig :
  BRAND === 'bfai' ? bfaiConfig :
  cybertConfig;

// Export types
export { BrandConfig } from './types';

// Export all configs for build-time access
export { cybertConfig, gstackConfig };
